import { TrackJS } from 'trackjs';
import { useDebugModeStore } from '~/stores/debug';

class Logger {
  static error = (message, ...rest) => {
    const composedMessage = `${message} ${
      rest.length > 0 ? `[${JSON.stringify(rest)}]` : ''
    }`;
    if (TrackJS) {
      TrackJS.track(composedMessage);
    }

    const { debugMode } = useDebugModeStore.getState();
    if (ENVIRONMENT !== 'production' || debugMode) {
      console.error(composedMessage);
    }
  };
}

export default Logger;
